import React from 'react';
import { useTranslate } from 'nucleus-text';
import AttendeesSVG from '@illustrations/AttendeesSVG';
import Button from '@cvent/carina/components/Button';
import useBreakpoints from '@hooks/useBreakpoints';
import Link from 'next/link';
import LayoutSpacer from '@components/layout/Spacer';
import ContentSection from '@cvent/blocks/components/templates/ContentSection';
import BlockHeader from '@cvent/blocks/components/BlockHeader';

interface AttendeesMeetProps {
  eventId: string;
}

function AttendeesMeetButton({ eventId }: AttendeesMeetProps): JSX.Element {
  const { translate } = useTranslate();

  return (
    <>
      <LayoutSpacer size={1 / 2} />
      <Link href={`/events/${eventId}/attendees`} passHref legacyBehavior>
        <Button
          text={translate('Attendees-Meet-Section-Button-Text')}
          element="a"
          isBlock={false}
          css={{
            width: 'fit-content'
          }}
          testID="view-attendees-button"
          size="l"
        />
      </Link>
    </>
  );
}

function AttendeesMeet({ eventId }: AttendeesMeetProps): JSX.Element {
  const { translate } = useTranslate();
  const { isMobile } = useBreakpoints();

  return (
    <ContentSection
      textContent={
        <>
          <BlockHeader>{translate('Attendees-Meet-Section-Title')}</BlockHeader>
          <p>{translate('Attendees-Meet-Section-Description')}</p>
          {!isMobile && <AttendeesMeetButton eventId={eventId} />}
        </>
      }
      mediaContent={
        <>
          <AttendeesSVG testID="feature-section-image" />
          {isMobile && <AttendeesMeetButton eventId={eventId} />}
        </>
      }
    />
  );
}

export default AttendeesMeet;
